import PropTypes from "prop-types";
import { useEffect, useMemo, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
// routes
import { paths } from "src/routes/paths";
// hooks
import { useAuthContext } from "src/auth/hooks";
// redux
import { store } from "src/redux/store";
// sections
// utils
//
import { RECAPTCHA_KEY } from "src/config-global";

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
    const { pathname, search } = useLocation();

    const { authenticated } = useAuthContext();
    //


    // 只在首次渲染同步读取一次，避免后续 render 抖动
    const storedDestination = useMemo(() => {
        try {
            return localStorage.getItem("storedDestination") || "";
        } catch {
            return "";
        }
    }, []);

    // ----------------------------------

    useEffect(() => {
        store.dispatch({ type: "RESET" });

        return () => {
            // Remove reCAPTCHA script
            const script = document.getElementById("google-recaptcha-v3");
            if (script) script.remove();

            // Remove reCAPTCHA badge (if needed)
            const badge = document.querySelector(".grecaptcha-badge");
            if (badge) badge.remove();
        };
    }, []);

    // 已登录：优先走一次性目的地，其次回到 dashboard
    if (authenticated) {
        if (storedDestination) {
            // 只用一次就删，避免后续误跳
            try {
                localStorage.removeItem("storedDestination");
            } catch (error) {
                console.error(error);
            }

            return <Navigate to={ storedDestination } replace />;
        }

        return <Navigate to={ `${ paths.dashboard.shipments.root }${ search }` } replace />;
    }

    return (
        <GoogleReCaptchaProvider reCaptchaKey={ RECAPTCHA_KEY } useRecaptchaNet>
            { children }
        </GoogleReCaptchaProvider>
    );
}

GuestGuard.propTypes = {
    children: PropTypes.node
};
